<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';


    onMount(async() => {

    });

</script>

<Iqtemplate
    top_container_background={false}
>
<div class="cszinputcontainer">
    <div class="cszinputfieldcontainer">
        <div class="thankyoutext">Thank you!</div>
        <div class="thankyoucopy">One of our Loan Experts will contact you shortly.</div>
    </div>
</div>


</Iqtemplate>

<style>
.thankyoutext {
    font-size: 1.5em;
    margin-top: 50px;
}
.thankyoucopy {
    margin-top: 20px;
   color: #657680;
}
</style>